<aside
    class="sidebar"
    [class.sidebar-mobile]="sidebarService.isBelowTabletWidth()"
    [class.sidebar-wider]="sidebarService.isBelowTabletWidth()"
    [class.sidebar-hidden]="sidebarService.isBelowTabletWidth() && !sidebarService.isNavSidebarEnabled()"
    [class.sidebar-fullscreen]="sidebarService.isBelowMobileWidth() && sidebarService.isNavSidebarEnabled()"
>
    <section>
        <div class="sidebar-header">
            <div class="sidebar-header-logo">
                @if (!sidebarService.isBelowMobileWidth() && sidebarService.isBelowTabletWidth()) {
                    <img src="assets/icons/close-nav-cross.svg" alt="Burger Icon" class="sidebar-header-close sidebar-header-logo-close" (click)="sidebarService.disableSidebar()" />
                }
                <div class="sidebar-header-logo-img" (click)="sidebarService.disableSidebar()" [routerLink]="['/home']">
                    <img src="assets/icons/dashboard-logo.svg" alt="Airwallet Logo" />
                    @if (dashboardOwnerUser.operatorName) {
                        <div class="sidebar-header-logo-img-operator">
                            <app-aw-tooltip [tooltipTitle]="'navbar.main_operator' | translate">
                                <ng-container tooltip_element_ref>
                                    <img width=".875rem" height="auto" src="assets/icons/operator-notify-icon.svg" alt="Info" />
                                </ng-container>

                                <ng-container description>
                                    <div>
                                        <span style="font-weight: 600"> {{ dashboardOwnerUser.operatorName }} </span>{{ "navbar.main_operator_description_long_pt1" | translate }}
                                    </div>
                                    <div class="mt-2">
                                        {{ "navbar.main_operator_description_long_pt2" | translate }}
                                    </div>
                                    <div class="mt-2">
                                        {{ "navbar.main_operator_description_long_pt3" | translate }}
                                        {{ dashboardOwnerUser.operatorName }}
                                        {{ "navbar.main_operator_description_long_pt4" | translate }}
                                    </div>
                                </ng-container>
                            </app-aw-tooltip>
                        </div>
                    }
                </div>
                <div class="sidebar-header-logo-titles">
                    @if (samlService.samlMembershipOwners()) {
                        <app-owner-selector />
                    } @else {
                        <div class="ellipsis">
                            <span>
                                @if (isDemo) {
                                    <strong [title]="'navbar.demo_acc' | translate">{{ "navbar.demo_acc" | translate }}</strong>
                                } @else {
                                    <strong [title]="dashboardOwnerUser.company_name">{{ dashboardOwnerUser.company_name }}</strong>
                                }
                            </span>
                        </div>
                    }
                    <div class="ellipsis" [title]="authenticatedUser.name">
                        <span style="font-size: 12px">{{ authenticatedUser.name }}</span>
                    </div>
                </div>
            </div>
            @if (sidebarService.isBelowMobileWidth()) {
                <img src="assets/icons/close-nav-cross.svg" alt="Burger Icon" class="sidebar-header-close" (click)="sidebarService.disableSidebar()" />
            }
        </div>
    </section>
    <section class="sidebar-section">
        <div>
            <nav class="nav">
                <!-- Overview -->
                @if (authService.allowAccess("home", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-home" (click)="sidebarService.disableSidebar()" [routerLink]="['/home']">
                        <img src="assets/icons/nav-icons-black/home.svg" alt="overview icon" />
                        <span>{{ "navbar.home" | translate }}</span>
                    </a>
                }
                <!-- Transactions -->
                @if (authService.allowAccess("transactions", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-transactions" (click)="sidebarService.disableSidebar()" [routerLink]="['/transactions']">
                        <img src="assets/icons/nav-icons-black/transactions.svg" alt="transactions icon" />
                        <span>{{ "navbar.transactions" | translate }}</span>
                    </a>
                }
                <!-- topups -->
                @if (authService.customerFirestore()?.wallet_float_owner) {
                    <a role="button" class="nav-link" id="nav-topups" (click)="sidebarService.disableSidebar()" [routerLink]="['/topups']">
                        <img src="assets/icons/nav-icons-black/topups.svg" alt="topups icon" />
                        <span>{{ "navbar.topups" | translate }}</span>
                    </a>
                }
                <!-- Location -->
                @if (authService.allowAccess("locations", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-locations" (click)="sidebarService.disableSidebar()" [routerLink]="['/locations']">
                        <img src="assets/icons/nav-icons-black/locations.svg" alt="locations icon" />
                        <span>{{ "misc.locations" | translate }}</span>
                    </a>
                }

                <!-- Actions -->
                @if (authService.allowAccess("actions", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-actions" (click)="sidebarService.disableSidebar()" [routerLink]="['/actions']">
                        <img src="assets/icons/nav-icons-black/actions.svg" alt="actions icon" />
                        <span>{{ "operator.filter_bar.actions" | translate }}</span>
                        @if (!isActionsEnabled()) {
                            <img class="upgrade-star" src="assets/icons/upgrade-star-blue.svg" alt="upgrade-star" />
                        }
                    </a>
                }
                <!-- All Devices -->
                @if (authService.allowAccess("devices", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-devices" (click)="sidebarService.disableSidebar()" [routerLink]="['/devices']">
                        <img src="assets/icons/nav-icons-black/device.svg" alt="device icon" />
                        <span>{{ "navbar.devices" | translate }}</span>
                        @if (!isOperatorDevicesEnabled()) {
                            <img class="upgrade-star" src="assets/icons/upgrade-star-blue.svg" alt="upgrade-star" />
                        }
                    </a>
                }
                <!-- Health Monitor -->
                @if (authService.allowAccess("health-monitor", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-health-monitor" (click)="sidebarService.disableSidebar()" [routerLink]="['/health-monitor']">
                        <img src="assets/icons/nav-icons-black/health-monitor.svg" alt="health-monitor icon" />
                        <span>{{ "navbar.health-monitor" | translate }}</span>
                        @if (!isOperatorHealthMonitorEnabled()) {
                            <img class="upgrade-star" src="assets/icons/upgrade-star-blue.svg" alt="upgrade-star" />
                        }
                    </a>
                }
            </nav>
            @if (authService.isOperator()) {
                <nav class="nav">
                    <div class="nav-title">
                        <strong>{{ "navbar.operator" | translate }}</strong>
                    </div>
                    @if (authService.allowAccess("customers", authService.getRole())) {
                        <a role="button" class="nav-link" id="nav-customers" (click)="sidebarService.disableSidebar()" [routerLink]="['/customers']">
                            <img src="assets/icons/nav-icons-black/customers.svg" alt="customers icon" />
                            <span>{{ "customers.customers" | translate }}</span>
                        </a>
                    }
                    @if (authService.allowAccess("contracts", authService.getRole())) {
                        <a role="button" class="nav-link" id="nav-contracts" (click)="sidebarService.disableSidebar()" [routerLink]="['/contracts']">
                            <img src="../../../assets/icons/nav-icons-black/contracts.svg" alt="contract icon" />
                            <span>{{ "navbar.contracts" | translate }}</span>
                        </a>
                    }
                </nav>
            }

            <nav class="nav">
                @if (authService.allowAccessToAny(["users", "coupons", "push-notifications"], authService.getRole())) {
                    <div class="nav-title">
                        <strong>{{ "navbar.engagement" | translate }}</strong>
                    </div>
                }

                @if (authService.allowAccess("users", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-users" (click)="sidebarService.disableSidebar()" [routerLink]="['/users']">
                        <img src="assets/icons/nav-icons-black/users.svg" alt="users icon" />
                        <span class="linkTitle">{{ "navbar.users" | translate }}</span>
                    </a>
                }
                @if (this.authService.isCouponAllowed() && authService.allowAccess("coupons", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-coupons" (click)="sidebarService.disableSidebar()" [routerLink]="['/coupons']">
                        <img src="assets/icons/nav-icons-black/coupons.svg" alt="coupon icon" />
                        <span>{{ "navbar.coupons" | translate }}</span>
                    </a>
                }

                @if (authService.allowAccess("push-notifications", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-push-notifications" (click)="sidebarService.disableSidebar()" [routerLink]="['/push-notifications']">
                        <img src="assets/icons/nav-icons-black/push-notifications.svg" alt="push-notifications icon" />
                        <span class="linkTitle">{{ "navbar.push-notifications" | translate }}</span>
                    </a>
                }
            </nav>
        </div>

        <div class="end">
            <a role="button" class="end-feedback" id="feedback" href="https://docs.google.com/forms/d/1O8Rzv2slSQ94arztqQ8_TEIhYkwqU2GqTJZZvL9j3sA/preview" target="_blank">
                <span>{{ "navbar.share_feedback" | translate }}</span>
                <img src="assets/icons/arrow-right-black.svg" alt="arrow right" />
            </a>
            <nav class="nav">
                <div class="nav-title">
                    <strong>{{ "navbar.settings" | translate }}</strong>
                </div>

                @if (authService.allowAccess("account", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-account" (click)="sidebarService.disableSidebar()" [routerLink]="['/account']">
                        <img src="assets/icons/nav-icons-black/account.svg" alt="account icon" />
                        <span>{{ "navbar.settings_account" | translate }}</span>
                    </a>
                }
                @if (authService.isBillingAllowed() && authService.allowAccess("billing", authService.getRole()) && !dashboardOwnerUser.settings.is_regular) {
                    <a role="button" class="nav-link" id="nav-billing" (click)="sidebarService.disableSidebar()" [routerLink]="['/billing']">
                        <img src="assets/icons/nav-icons-black/billing.svg" alt="billing icon" />
                        <span>{{ "misc.billing" | translate }}</span>
                    </a>
                }
                @if (authService.allowAccess("settlements", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-settlements" (click)="sidebarService.disableSidebar()" [routerLink]="['/settlements']">
                        <img src="assets/icons/nav-icons-black/settlements.svg" alt="settlements icon" />
                        <span>{{ "navbar.settings_settlements" | translate }}</span>
                    </a>
                }
                @if (authService.allowAccess("members", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-members" (click)="sidebarService.disableSidebar()" [routerLink]="['/members']">
                        <img src="assets/icons/nav-icons-black/members.svg" alt="members icon" />
                        <span>{{ "members.members" | translate }}</span>
                    </a>
                }
                @if (authService.isDeveloper() && authService.allowAccess("developer", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-developer" (click)="sidebarService.disableSidebar()" [routerLink]="['/developer']">
                        <img src="assets/icons/nav-icons-black/developer.svg" alt="developer icon" />
                        <span>Developer</span>
                    </a>
                }
                <div class="log-out">
                    <a role="button" class="nav-link" (click)="signOut()">
                        <img src="assets/icons/nav-icons-black/log-out.svg" alt="log-out icon" />
                        <span>{{ "navbar.settings_log_out" | translate }}</span>
                    </a>
                </div>
            </nav>
        </div>
    </section>
</aside>
